import { render, staticRenderFns } from "./AppointmentBranchChooseBranch.vue?vue&type=template&id=5b3e126d"
import script from "./AppointmentBranchChooseBranch.vue?vue&type=script&lang=ts"
export * from "./AppointmentBranchChooseBranch.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentBranchChooseBranch.vue?vue&type=style&index=0&id=5b3e126d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports